/** Hộp thoại dùng chung của diễn đàn: nhập lý do (gỡ bài / báo cáo), xác nhận xoá bài của mình. */
import { Input, Modal } from "antd";

/** Hỏi 1 dòng lý do. Trả về chuỗi (có thể rỗng nếu `optional`) hoặc null nếu huỷ. */
export function promptReason(opts: {
  title: string;
  placeholder: string;
  okText: string;
  optional?: boolean;
  danger?: boolean;
}): Promise<string | null> {
  return new Promise((resolve) => {
    let value = "";
    Modal.confirm({
      title: opts.title,
      icon: null,
      okText: opts.okText,
      cancelText: "Huỷ",
      okButtonProps: { danger: opts.danger },
      content: (
        <Input.TextArea
          autoFocus
          rows={3}
          maxLength={500}
          placeholder={opts.placeholder}
          onChange={(e) => (value = e.target.value)}
          style={{ marginTop: 8 }}
        />
      ),
      onOk: () => {
        if (!opts.optional && !value.trim()) return Promise.reject();
        resolve(value.trim());
      },
      onCancel: () => resolve(null),
    });
  });
}

export function confirmDelete(what: string): Promise<boolean> {
  return new Promise((resolve) => {
    Modal.confirm({
      title: `Xoá ${what}?`,
      content: "Nội dung sẽ bị xoá vĩnh viễn, chỉ còn dòng “đã bị tác giả xoá”.",
      okText: "Xoá",
      okButtonProps: { danger: true },
      cancelText: "Huỷ",
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
}

/** Đưa con trỏ vào editor trong khối có `id` (vd khi bấm "Trả lời" một bài). */
export function focusForumEditor(containerId: string) {
  const el = document.querySelector<HTMLElement>(`#${containerId} .ProseMirror`);
  el?.scrollIntoView({ behavior: "smooth", block: "center" });
  el?.focus();
}
